import { type FC, type ReactNode, use, useMemo, useState } from 'react'
import { createPortal } from 'react-dom'
import { InternalDebugPortalContext } from './InternalDebugPortalContext'

export const DebugPortalContextProvider: FC<{ children?: ReactNode }> = ({ children }) => {
  const [debugElementsRoot, setDebugElementsRoot] = useState<HTMLElement | null>(null)
  const contextValue = useMemo(
    () => ({
      debugElementsRoot,
      setDebugElementsRoot: (element: HTMLElement | null) => {
        setDebugElementsRoot((_prev) => element)
      },
    }),
    [debugElementsRoot],
  )

  return <InternalDebugPortalContext.Provider value={contextValue}>{children}</InternalDebugPortalContext.Provider>
}

export const DebugContent = ({ children }: { children: ReactNode }) => {
  const { debugElementsRoot } = use(InternalDebugPortalContext)
  return debugElementsRoot ? createPortal(children, debugElementsRoot) : null
}
